import {type IBrandPortal} from '../schema';
import {getCurrentPortal} from './getCurrentPortal';

export const getCurrentPortalProp = <K extends keyof IBrandPortal>(key: K) =>
	getCurrentPortal()?.[key];
